import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { tv as b } from "tailwind-variants";
const l = {
  1: "newbie",
  2: "junior",
  3: "intermediate",
  4: "advanced",
  5: "guru"
}, s = b({
  slots: {
    wrapper: ["border", "inline-flex", "rounded", "w-min"],
    number: ["font-bold", "font-secondary", "text-white", "text-sm", "px-2"],
    label: ["font-bold", "font-secondary", "px-2", "text-sm", "uppercase"]
  },
  variants: {
    level: {
      1: {
        wrapper: ["border-cyan-500"],
        number: ["bg-cyan-500"],
        label: ["text-cyan-500"]
      },
      2: {
        wrapper: ["border-emerald-400"],
        number: ["bg-emerald-400"],
        label: ["text-emerald-400"]
      },
      3: {
        wrapper: ["border-amber-400"],
        number: ["bg-amber-400"],
        label: ["text-amber-400"]
      },
      4: {
        wrapper: ["border-orange-500"],
        number: ["bg-orange-500"],
        label: ["text-orange-500"]
      },
      5: {
        wrapper: ["border-rose-600"],
        number: ["bg-rose-600"],
        label: ["text-rose-600"]
      }
    }
  }
}), p = ({ level: e }) => {
  const { wrapper: a, number: n, label: t } = s({ level: e });
  return /* @__PURE__ */ o("div", { className: a(), children: [
    /* @__PURE__ */ r("span", { className: n(), color: "white", children: e }),
    /* @__PURE__ */ r("span", { className: t(), children: l[e] })
  ] });
};
export {
  p as default
};
